import EnhancedSearchResultsHeader from '@components/Search/EnhancedSearchResultsHeader'
import SearchInput from '@components/Search/SearchInput'

import Container from './Container'
import ResultsContainer from './ResultsContainer'
import ResultsHeader from './ResultsHeader'
import ResultsStatus from './ResultsStatus'
import SearchMessage from './SearchMessage'

const exports = {
  Container,
  SearchInput,
  ResultsContainer,
  ResultsStatus,
  ResultsHeader,
  SearchMessage,
  EnhancedSearchResultsHeader,
}

export default exports
